import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CheckCircle, Home, Receipt } from 'lucide-react'

export const OrderSuccessPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 max-w-md w-full">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600 dark:text-green-400" />
        </div>

        {/* Success Message */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white text-center mb-2">
          Ordine confermato!
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-center mb-8">
          Il tuo ordine è stato inviato alla cucina. Riceverai una notifica quando sarà pronto.
        </p>

        {/* Order Info */}
        <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-3">
            <Receipt className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                Cosa succede ora?
              </h3>
              <ul className="text-sm text-gray-600 dark:text-gray-400 space-y-1">
                <li>• La cucina ha ricevuto il tuo ordine</li>
                <li>• Inizieranno a prepararlo a breve</li>
                <li>• Ti avviseremo quando sarà pronto</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/menu')}
            className="w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <Home className="w-5 h-5" />
            <span>Torna al menu</span>
          </button>

          <button
            onClick={() => navigate('/orders')}
            className="w-full px-6 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-900 dark:text-white font-medium rounded-lg transition-colors"
          >
            Visualizza i miei ordini
          </button>
        </div>

        {/* Additional Info */}
        <p className="mt-6 text-xs text-center text-gray-500 dark:text-gray-400">
          Tempo di attesa stimato: 15-20 minuti
        </p>
      </div>
    </div>
  )
}
